import { Stack, Box, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { Assignee } from '@/components/tour/notes/types';

type RowProps = {
  minutes: number;
};
export function RowBoardLabel({ minutes }: RowProps) {
  if (minutes % 60 !== 0) return null;

  const startOfDay = dayjs().startOf('day');
  const time = startOfDay.add(minutes, 'minute');
  return (
    <Typography
      sx={{
        color: '#667085',
        textAlign: 'right',
        fontFamily: 'Inter',
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '16px',
      }}
    >
      {time.format('H:mm')}
    </Typography>
  );
}

type ColumnProps = {
  assignee: Assignee;
};
export function ColumnBoardLabel({ assignee }: ColumnProps) {
  return (
    <Stack direction="row" gap="6px" alignItems="center">
      <Box
        sx={{
          width: '6px',
          height: '6px',
          flexShrink: 0,
          backgroundColor: assignee.color || '#0BA5EC',
          borderRadius: '50%',
        }}
      />
      <Typography
        sx={{
          color: '#667085',
          fontFamily: 'Inter',
          fontSize: '12px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: '16.5px',
        }}
      >
        {assignee.name}
      </Typography>
    </Stack>
  );
}

type ColumnGroupProps = {
  dayTimestamp: number;
};
export function ColumnGroupBoardLabel({ dayTimestamp }: ColumnGroupProps) {
  const date = dayjs.unix(dayTimestamp);

  const dayOfWeek: string = date.format('ddd');
  const formattedDate: string = date.format('DD MMM');

  const today = dayjs();
  const isToday: boolean = date.isSame(today, 'day');

  return (
    <Stack
      direction="row"
      gap="5px"
      sx={{
        textAlign: 'center',
        color: '#101828',
        fontFamily: 'Inter',
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '24px',
      }}
    >
      <Typography
        sx={{
          fontFamily: 'inherit',
          fontSize: 'inherit',
          fontWeight: 'inherit',
          lineHeight: 'inherit',
          color: 'inherit',
        }}
      >
        {dayOfWeek}
      </Typography>
      <Typography
        sx={{
          fontFamily: 'inherit',
          fontSize: 'inherit',
          fontWeight: 'inherit',
          lineHeight: 'inherit',
          color: isToday ? 'var(--Brand-Main-Blue, #2055FF)' : 'var(--Gray-500, #667085)',
        }}
      >
        {formattedDate}
      </Typography>
    </Stack>
  );
}
